import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { sendHoverSoundCommand, sendTabClickSoundCommand } from '../../../helpers/web_to_client'

import styles from './TableRowExpandable.css'

const propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func.isRequired,

    isOwn: PropTypes.bool,
    isActive: PropTypes.bool,
    isArrowVisible: PropTypes.bool,
    arrowTooltipId: PropTypes.string,
}

const defaultProps = {
    isArrowVisible: true,
}

const TableRowExpandable = (props) => {
    const classNameBase = classNames(styles.trExpandable, {
        [styles.trExpandable__isOwn]: props.isOwn,
        [styles.trExpandable__isActive]: props.isActive,
    })

    const conditionOwn = props.isOwn ? (
        <div className={classNames(styles.trExpandableCondition, styles.trExpandableCondition__own)} />
    ) : null

    const arrowDataAttrs = props.arrowTooltipId ? {
        'data-tip': true,
        'data-for': props.arrowTooltipId,
    } : {}

    const arrow = props.isArrowVisible ? (<div className={styles.trArrow} {...arrowDataAttrs} />) : null

    return (
        <div
            className={classNameBase}
            onMouseDown={sendTabClickSoundCommand}
            onMouseEnter={props.isActive ? null : sendHoverSoundCommand}
            onClick={props.onClick}
        >
            <div className={classNames(styles.trExpandableCondition, styles.trExpandableCondition__hover)} />
            <div className={classNames(styles.trExpandableCondition, styles.trExpandableCondition__active)} />
            {conditionOwn}
            {arrow}
            {props.children}
        </div>
    )
}

TableRowExpandable.propTypes = propTypes
TableRowExpandable.defaultProps = defaultProps

export default TableRowExpandable



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/Table/TableRowExpandable/TableRowExpandable.jsx